import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import {
  runProductsSearchSchema,
  type RunProductsSearch,
} from '~/features/catalog-v2/utils/run-products-search';

const RunProductsPage = lazy(() => import('~/features/catalog-v2/pages/run-products-page'));

export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/runs/$runId/products/')({
  validateSearch: runProductsSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  // Filter/page changes replace the history entry so Back leaves the screen, not the filter.
  const onSearchChange = (patch: Partial<RunProductsSearch>) => {
    void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true });
  };

  return (
    <Suspense fallback={<PageSkeleton />}>
      {/* Keyed by batch so switching batches never carries one batch's state into the next. */}
      <RunProductsPage key={runId} runId={runId} search={search} onSearchChange={onSearchChange} />
    </Suspense>
  );
}
